export default __webpack_public_path__ + "static/media/heroHeader.a22aa27a.png";